import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import MetadataObject from '../MetadataObject';
import uuid from '@afosto/utils/uuid';

const MetadataObjectArray = ({ label, value, schema }) => (
  <>
    <Typography variant="subtitle1">{label}</Typography>
    {value.map(
      item =>
        item && (
          <Box py={1} key={uuid()}>
            <Card variant="outlined">
              <MetadataObject label={undefined} value={item} schema={schema} />
            </Card>
          </Box>
        ),
    )}
  </>
);

MetadataObjectArray.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.array,
  schema: PropTypes.object,
};

MetadataObjectArray.defaultProps = {
  value: [],
  schema: {},
};

export default MetadataObjectArray;
